import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { DreamerIcon } from "@/components/controls/Questions/DreamerIndication/components/DreamerIcon";
import { cn } from "@/utils/utils";

interface AutofillIndicationProps {
  className?: string;
}

const AutofillIndication: React.FC<AutofillIndicationProps> = ({
  className
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "inline-flex w-fit items-center gap-1 rounded-[10px] border-[0.5px] border-border-border1 bg-surface-field-default p-[2px] pr-[6px]",
        className
      )}
    >
      <DreamerIcon size="sm" shouldUseIconContainer />
      <Text variant="smBodySecondary">
        {t("deals.dealView.filledByDreamer.filledByDreamer")}
      </Text>
    </div>
  );
};

export default AutofillIndication;
